import { Skeleton } from './ui/skeleton';

export const HeroSkeleton = () => (
  <section className="min-h-screen flex items-center justify-center px-4 py-20">
    <div className="max-w-4xl mx-auto text-center space-y-8">
      <div className="flex justify-center">
        <Skeleton className="w-32 h-32 rounded-full" />
      </div>
      <div className="space-y-4">
        <Skeleton className="h-14 w-96 mx-auto" />
        <Skeleton className="h-8 w-[500px] mx-auto" />
      </div>
      <div className="flex gap-4 justify-center">
        <Skeleton className="h-11 w-32" />
        <Skeleton className="h-11 w-32" />
        <Skeleton className="h-11 w-40" />
      </div>
    </div>
  </section>
);

export const AboutSkeleton = () => (
  <section className="py-20 px-4 bg-muted/30">
    <div className="max-w-4xl mx-auto space-y-8">
      <div className="text-center space-y-4">
        <Skeleton className="h-10 w-48 mx-auto" />
        <Skeleton className="h-6 w-[600px] mx-auto" />
        <Skeleton className="h-6 w-[500px] mx-auto" />
      </div>
      <div className="grid sm:grid-cols-2 gap-4 pt-8">
        {[1, 2, 3, 4].map((i) => (
          <Skeleton key={i} className="h-24 w-full" />
        ))}
      </div>
    </div>
  </section>
);

export const PortfolioSkeleton = () => (
  <section className="py-20 px-4">
    <div className="max-w-7xl mx-auto space-y-12">
      <div className="text-center space-y-4">
        <Skeleton className="h-10 w-64 mx-auto" />
        <Skeleton className="h-6 w-[500px] mx-auto" />
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
        {[1, 2, 3, 4, 5, 6, 7, 8].map((i) => (
          <div key={i} className="space-y-4">
            <Skeleton className="w-full aspect-square" />
            <Skeleton className="h-6 w-3/4" />
            <Skeleton className="h-4 w-full" />
            <Skeleton className="h-4 w-full" />
          </div>
        ))}
      </div>
    </div>
  </section>
);

export const ContactSkeleton = () => (
  <section className="py-20 px-4 bg-muted/30">
    <div className="max-w-4xl mx-auto space-y-8">
      <div className="text-center">
        <Skeleton className="h-10 w-48 mx-auto" />
      </div>
      <div className="grid sm:grid-cols-2 gap-6">
        {[1, 2, 3, 4].map((i) => (
          <Skeleton key={i} className="h-16 w-full" />
        ))}
      </div>
    </div>
  </section>
);
